module.exports = __webpack_public_path__ + "static/media/s1.aee15021.png";